import {Component, ViewChild, ElementRef} from '@angular/core';
import {IonicPage, AlertController, NavParams, ViewController, ModalController} from 'ionic-angular';
import {
    HomogenizationOrderApi, HomogenizationOrderInLineApi, HomogenizationOrderOutLineApi,
    PartnerApi, ProductApi,
    StockLocationApi,
    StockWarehouseLocationApi
} from "../../sdk";
import {HomogenizationOrder, HomogenizationOrderOutLine} from '../../sdk';
import {BaseViewComponent} from '../../components/baseViewComponent';
import {LoadingComponent} from '../../components/loadingComponent';
import {LoopBackAuth} from "../../sdk";
import {ServerProvider} from "../../providers/server-provider";

@IonicPage({
    segment: 'homogenization-order-outline-add',
    name: 'HomogenizationOrderOutlineAddPage'
})
@Component({
    selector: 'page-homogenization-order-outline-add',
    templateUrl: 'homogenization-order-outline-add.html',
})
export class HomogenizationOrderOutlineAddPage extends BaseViewComponent {

    @ViewChild('noteTextArea') noteTextArea: ElementRef;

    public order: HomogenizationOrder;
    public createOutLine: HomogenizationOrderOutLine;
    public isOpenModal: boolean = false;

    constructor(
        public alertCtrl: AlertController,
        public params: NavParams,
        public homogenizationOrderService: HomogenizationOrderApi,
        public homogenizationOrderOutLineService: HomogenizationOrderOutLineApi,
        public homogenizationOrderInLineService: HomogenizationOrderInLineApi,
        public partnerService: PartnerApi,
        public viewCtrl: ViewController,
        public loading: LoadingComponent,
        public modalCtrl: ModalController,
        public authService: LoopBackAuth,
        public stockWarehouseLocationService: StockWarehouseLocationApi,
        public stockLocationService: StockLocationApi,
        public productService: ProductApi,
    ) {
        super();
        this.order = new HomogenizationOrder();
        this.createOutLine = new HomogenizationOrderOutLine();
    }


    ionViewDidLoad() {
        super.ionViewDidLoad();
        this.order = this.params.get("order");
        this.setDefaults();
    }

    public setDefaults() {
        this.createOutLine.homogenization_order_id = this.order.id
        this.createOutLine.company = this.order.company
        this.createOutLine.company_id = this.order.company_id
        this.createOutLine.user = this.order.user
        this.createOutLine.user_id = this.order.user_id
        this.createOutLine.product = this.order.product
        this.createOutLine.product_id = this.order.product_id
        this.createOutLine.locationDest = this.order.locationDest
        this.createOutLine.location_dest_id = this.order.location_dest_id
        this.createOutLine.location = this.order.location
        this.createOutLine.location_id = this.order.location_id
        if (this.order.product.uom) {
            this.createOutLine.productUom = this.order.product.uom
            this.createOutLine.product_uom_id = this.order.product.uom_id
        } else {
            delete this.createOutLine.productUom
            delete this.createOutLine.product_uom_id
        }
        this.createOutLine.product_qty = 0
        this.createOutLine.state = 'draft'
    }

    public getStateOutLine(): string {
        return this.createOutLine.state
    }

    public selectStateOutLine() {
        return
    }

    public getLocationDestOutLine(): string {
        if (this.createOutLine.locationDest) {
            return this.createOutLine.locationDest.name;
        }
        return ""
    }

    public selectLocationDestOutLine() {
        return
    }

    public getPackageOutLine() {
        if (this.createOutLine.package) {
            return this.createOutLine.package.name;
        }
        return "";
    }

    public selectPackageOutLine() {
        return
    }

    public getProdLotOutLine() {
        if (this.createOutLine.prodLot) {
            return this.createOutLine.prodLot.name;
        }
        return "";
    }

    public selectProdLotOutLine() {
        return
    }

    public getLocationOutLine(): string {
        if (this.createOutLine.location) {
            return this.createOutLine.location.name;
        }
        return "";
    }

    public focusQty() {
        // Verificar si el valor es 0 y borrarlo
        if (this.createOutLine.product_qty === 0) {
            this.createOutLine.product_qty = null;
        }
    }

    public selectLocationOutLine() {
        return
    }

    public getProductOutLine(): string {
        if (this.createOutLine.product) {
            return this.createOutLine.product.name;
        }
        return "";
    }

    public selectProductOutLine(): void {
        return
    }

    public getProductOutLineUOMName(): String {
        if (this.createOutLine && this.createOutLine.product && this.createOutLine.productUom) {
            return this.createOutLine.productUom.name;
        }
        return null;
    }

    public getLotAndPackageOutLine() {
        this.loading.create({content: 'Asignando lote y paquete...', showBackdrop: false});
        ServerProvider.createOrUpdate(this.homogenizationOrderOutLineService, this.createOutLine).subscribe(success => {
            if (success) {
                this.homogenizationOrderOutLineService.get_lot_and_package(this.createOutLine.id, ServerProvider.getCustomHeaders).subscribe(success => {
                    this.loading.dismiss();
                    this.dismiss(true);
                }, error => {
                    console.log(error)
                    this.loading.dismiss();
                    this.dismiss(true);
                })
            }
        }, error => {
            this.loading.dismiss()
            console.log('Ha ocurrido un error.')
        })
    }

    public processOutLine() {
        this.loading.create({content: 'Procesando...', showBackdrop: false});
        //ServerProvider.createOrUpdate(this.homogenizationOrderOutLineService, this.createOutLine).subscribe(success => {
        this.homogenizationOrderOutLineService.process(this.createOutLine.id, ServerProvider.getCustomHeaders).subscribe(success => {
            this.loading.dismiss();
            if (success) {
                this.loading.dismiss();
                this.dismiss(true);
            }
        }, error => {
            this.loading.dismiss();
            this.dismiss(true);
        })
        /*}, error => {
            this.loading.dismiss()
            console.log('Ha ocurrido un error')
        })*/
    }

    public createLine_assignPackageAndLot_Process() {
        this.loading.create({content: 'Asignando y creando...', showBackdrop: false});
        ServerProvider.createOrUpdate(this.homogenizationOrderOutLineService, this.createOutLine).subscribe(success => {
            if (success) {
                this.createOutLine.id = success.id
                this.homogenizationOrderOutLineService.get_lot_and_package(this.createOutLine.id, ServerProvider.getCustomHeaders).subscribe(success => {
                    this.homogenizationOrderOutLineService.process(this.createOutLine.id, ServerProvider.getCustomHeaders).subscribe(success => {
                        this.loading.dismiss();
                        this.dismiss(true);
                    }, error => {
                        console.log(error)
                    })

                }, error => {
                    console.log(error)
                    this.homogenizationOrderOutLineService.process(this.createOutLine.id, ServerProvider.getCustomHeaders).subscribe(success => {
                        this.loading.dismiss();
                        this.dismiss(true);
                    }, error1 => {
                        console.log(error1)
                    })
                })
            }
        })
    }

    public create() {
        this.loading.create({content: 'Creando...', showBackdrop: false});
        ServerProvider.createOrUpdate(this.homogenizationOrderOutLineService, this.createOutLine).subscribe(success => {
            this.loading.dismiss();
            this.dismiss(true);
        }, error => {
            this.loading.dismiss();
            this.dismiss(true);
        })
    }


    public dismiss(data = null) {
        this.viewCtrl.dismiss(data)
    }

    public resizeTextArea(event) {
        if (event && event.keyCode == 13) {
            var element = this.noteTextArea['_elementRef'].nativeElement.getElementsByClassName("text-input")[0];
            var scrollHeight = element.scrollHeight;
            element.style.height = scrollHeight + 'px';
            this.noteTextArea['_elementRef'].nativeElement.style.height = (scrollHeight + 16) + 'px';
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/homogenization-order-outline-add/homogenization-order-outline-add.ts